module.exports = __webpack_public_path__ + "img/bottom-back.0c1b0992.jpg";